"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var __jsx = _react["default"].createElement;
var SoldOut = function SoldOut() {
  var translations = {
    soldOut: (0, _langLibrary["default"])("sold out")
  };
  return __jsx(_react["default"].Fragment, null, translations.soldOut);
};
var _default = SoldOut;
exports["default"] = _default;